import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSetStripeOnboardingStatus } from '../state';
import fetchWithToken from '../services';
import Loading from './Loading';

const CheckOnboardingComplete = () => {
  const setStripeOnboardingStatus = useSetStripeOnboardingStatus();
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {

    const checkOnboardingComplete = async () => {
      try {
        // First check if we already have the onboarding status
        const userResponse = await fetchWithToken('/user?fields=stripeOnboardingStatus', {
          method: 'GET',
        });
        const userData = await userResponse.json();

        if (userData.stripeOnboardingStatus === 'complete') {
          setStripeOnboardingStatus('complete');
          setIsLoading(false);
          return;
        }

        if (userData.stripeOnboardingStatus === 'started') {
          setStripeOnboardingStatus('started');
          setIsLoading(false);
          return;
        }

        // If stripeOnboardingStatus is not set, proceed with Stripe check
        const response = await fetchWithToken('/check-stripe-onboarding', {
          method: 'POST',
        });
        const data = await response.json();
        console.log('Onboarding status:', data);

        if (data.onboardingComplete === true) {
          setStripeOnboardingStatus('complete');
          // Update the user's stripeOnboardingStatus
          await fetchWithToken('/update-stripe-onboarding-status', {
            method: 'POST',
            body: JSON.stringify({
              stripeOnboardingStatus: 'complete'
            })
          });
        } else {
          console.log('User has not submitted details through Stripe');
          setStripeOnboardingStatus('not_started');
          // Update the user's stripeOnboardingStatus
          await fetchWithToken('/update-stripe-onboarding-status', {
            method: 'POST',
            body: JSON.stringify({
              stripeOnboardingStatus: 'not_started'
            })
          });
        }
      } catch (error) {
        console.error('Error checking Stripe onboarding status:', error);
        setStripeOnboardingStatus('not_started');
        navigate('/error');
      } finally {
        setIsLoading(false);
      }
    };

    checkOnboardingComplete();
  }, [setStripeOnboardingStatus, navigate, fetchWithToken]);

  if (isLoading) {
    return <Loading />;
  }

  return null;
};

export default CheckOnboardingComplete;
